<template>
  <div>
    <a-spin
      :spinning="loading.page"
      tip="Preparing To Show Data ...  "
    >
      <div class="m-display-flex flex-column m-flex1">
        <a-row class="m-display-flex m-flex1">
          <a-col :xs="{ span: 24 }" :lg="{ span: 16 }" class="m-height-full">
            <a-row :gutter="16" class="m-width-full m-height-full m-display-flex flex-column">
              <a-col :xs="{ span: 24 }" :lg="{ span: 24 }" class="m-width-full m-height-full m-display-flex flex-column m-flex1">
                <a-card class="mcdm m-height-full m-display-flex flex-column m-flex1">
                  <div slot="title">
                    <div class="m-display-flex space-between">
                      <div>
                        <span>Salary Component Manifest - {{ moment(dataSource.header.periode,'YYYY-MM').format('MMMM YYYY') }}</span>
                      </div>
                      <a-popover slot="extra" trigger="click" placement="bottomRight">
                        <span slot="title">Select Action</span>
                        <ul class="m-list-wrapper bordered" slot="content">
                          <li v-if="getAuth.username == dataSource.header.tlc_create">
                            <a-button-group class="m-width-full">
                              <a-button
                                :disabled="dataSource.status_besar!='Revised'"
                                type="dashed"
                                icon="edit"
                                class="m-width-full"
                                @click="handleEdit"
                                >Edit</a-button
                              >
                              <!-- <a-button
                                @click="handleDelete"
                                :disabled="dataSource.status_besar=='Revised' "
                                type="danger"
                                icon="close-square"
                                :loading="loading.delete"
                                >Delete</a-button
                              > -->
                            </a-button-group>
                          </li>
                        </ul>
                        <a-button icon="more" :loading="loading.delete">Action</a-button>
                      </a-popover>
                    </div>
                  </div>
                  <template slot="extra">
                  </template>
                    <a-row :gutter="16">
                      <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
                        <ul class="m-list-wrapper bordered">
                          <li>
                            <span class="m-list-title" for>Description</span>
                            <span class="m-list-desc">{{ dataSource.header.catatan }}</span>
                          </li>
                        </ul>
                      </a-col>
                    </a-row>
                </a-card>
              </a-col>
            </a-row>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-collapse :class="getScreen ? 'margin-top m-height-full m-display-flex flex-column m-flex1' : 'm-height-full m-display-flex flex-column m-flex1'" activeKey="1">
              <a-collapse-panel key="1" class="m-flex1">
                <div
                  class="m-display-flex space-between align-middle"
                  slot="header"
                >
                  <h4 class="margin-remove">Status</h4>
                  <div>
                    <Status
                      :status="
                        dataSource.status_besar == 'Revised' &&
                        dataSource.cancel_sts == 1
                          ? 'Canceled'
                          : dataSource.status_besar
                      "
                    />
                    <a-button
                      @click="historyToggle"
                      type="default"
                      size="small"
                      class="margin-right-small"
                    >
                      <a-icon type="history" />
                    </a-button>
                  </div>
                </div>
                <a-timeline class="m-timeline">
                  <a-timeline-item color="green">
                    <div class="m-timeline-title">
                      Creator - {{ dataSource.header.tlc_create }}
                    </div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove">
                        {{
                          moment(dataSource.header.tgl_buat).format(
                            getDefaultDateFormat
                          )
                        }}
                      </h4>
                      <span class="m-text-small" v-if="dataSource.header.catatan">{{
                        dataSource.header.catatan
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <a-tag color="green">Created</a-tag>
                    </div>
                  </a-timeline-item>
                  <a-timeline-item
                    color="green"
                    v-for="workflow in dataSource.workflow"
                    :key="workflow.step_no"
                  >
                    <div class="m-timeline-title">
                      {{ workflow.actor }} - {{ workflow.tlc }}
                    </div>
                    <div class="m-timeline-body">
                      <h4
                        class="margin-remove"
                        v-if="workflow.tanggal_aksi !== null"
                      >
                        {{
                          moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                        }}
                      </h4>
                      <span class="m-text-small" v-if="workflow.remark">{{
                        workflow.remark
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <Status :status="workflow.status" />
                    </div>
                  </a-timeline-item>
                </a-timeline>
              </a-collapse-panel>
            </a-collapse>
          </a-col>
        </a-row>
      </div>

      <a-collapse :class="'margin-top'" activeKey="1">
        <a-collapse-panel key="1">
          <div
            class="m-display-flex space-between align-middle"
            slot="header"
          >
            <h4 class="margin-remove">Component Details</h4>
          </div>
            <a-table
              class="ccd margin-top"
              :columns="columns"
              :rowKey="(record, index) => {return index;}"
              :dataSource="dataSource.dtl"
              :pagination="pagination"
              size="small"
              :scroll="{ x: 2500, y: 400 }"
              bordered
            >
              <template slot="title">
                <a-row :gutter="16" type="flex" justify="space-between" align="middle">
                  <a-col>
                    <div class="title-table-top-left">Component Details</div>
                  </a-col>
                  <a-col>
                    <div class="m-display-flex flex-col">
                      <div class="m-display-flex flex-col" style="align-content: center;">
                        <b style="align-content: center;">Filter by Color :&nbsp;&nbsp;&nbsp;</b>
                        <a-checkbox v-model="filterBG.putih" @change="onChangeWhiteCheck" class="m-display-flex flex-col" style="align-content: center;top:2px">
                          <div style="width:50px; background-color: white;border: 1px solid #d9d9d9;">&nbsp;</div>
                        </a-checkbox>
                        <a-checkbox v-model="filterBG.merah" @change="onChangeWhiteCheck" class="m-display-flex flex-col" style="align-content: center;top:2px">
                          <div style="width:50px; background-color: rgba(231, 76, 60, 0.35);border: 1px solid #d9d9d9;">&nbsp;</div>
                        </a-checkbox>
                      </div>
                      <a-input-search
                        v-model="search"
                        style="width: 200px;"
                        class="margin-left"
                        placeholder="Quick Search ... "
                      />  
                    </div>
                  </a-col>
                </a-row>
              </template>
              <template slot="no" slot-scope="text, data, index">
                {{ pagination.current == 1 ? index+1 : ((pagination.current-1)*pagination.pageSize)+index+1 }}
              </template>
              <template slot="admin_bank" slot-scope="item">
                <div :class="item.admin_bank!=item.admin_bank_sebelum ? 'td_not_same':''">
                  <CurrencyJustified
                    currencyValue="IDR"
                    :valueNumber="item.admin_bank"
                  />
                </div>
              </template>
              <template slot="cop_perusahaan" slot-scope="item">
                <div :class="item.cop_perusahaan!=item.cop_perusahaan_sebelum ? 'td_not_same':''">
                  <CurrencyJustified
                    currencyValue="IDR"
                    :valueNumber="item.cop_perusahaan"
                  />
                </div>
              </template>
              <template slot="cop_karyawan" slot-scope="item">
                <div :class="item.cop_karyawan!=item.cop_karyawan_sebelum ? 'td_not_same':''">
                  <CurrencyJustified
                    currencyValue="IDR"
                    :valueNumber="item.cop_karyawan"
                  />
                </div>
              </template>
              <template slot="hutang_karyawan" slot-scope="item">
                <div :class="item.hutang_karyawan!=item.hutang_karyawan_sebelum ? 'td_not_same':''">
                  <CurrencyJustified
                    currencyValue="IDR"
                    :valueNumber="item.hutang_karyawan"
                  />
                </div>
              </template>
              <template slot="kesehatan_tambahan" slot-scope="item">
                <div :class="item.kesehatan_tambahan!=item.kesehatan_tambahan_sebelum ? 'td_not_same':''" style="text-align: right;">
                  {{ item.kesehatan_tambahan==0?'-':item.kesehatan_tambahan+" Orang" }}
                </div>
              </template>
              <template slot="potongan_koperasi" slot-scope="item">
                <div :class="item.potongan_koperasi!=item.potongan_koperasi_sebelum ? 'td_not_same':''">
                  <CurrencyJustified
                    currencyValue="IDR"
                    :valueNumber="item.potongan_koperasi"
                  />
                </div>
              </template>
              <template slot="pimpro" slot-scope="item">
                <div :class="item.pimpro!=item.pimpro_sebelum ? 'td_not_same':''">
                  <CurrencyJustified
                    currencyValue="IDR"
                    :valueNumber="item.pimpro"
                  />
                </div>
              </template>
              <template slot="car" slot-scope="item">
                <a-icon class="sts-c" theme="filled" type="check-square" v-if="item.car==1"/>
                <a-icon class="sts-c" type="close-square" v-else/>
              </template>
              <template slot="inactive" slot-scope="item">
                <div :class="item.inactive!=item.inactive_sebelum ? 'td_not_same m-width-full m-text-align right':'m-width-full m-text-align right'">
                  {{ item.inactive }}
                </div>
              </template>
              <template slot="absensi" slot-scope="item">
                <div :class="item.absensi!=item.absensi_sebelum ? 'td_not_same m-width-full m-text-align right':'m-width-full m-text-align right'">
                {{ item.absensi }}
                </div>
              </template>
              <template slot="makan" slot-scope="item">
                <div :class="item.makan!=item.makan_sebelum ? 'td_not_same':''">
                  <CurrencyJustified
                    currencyValue="IDR"
                    :valueNumber="item.makan"
                  />
                </div>
              </template>
              <!-- <template slot="kesehatan_karyawan" slot-scope="item">
                <a-checkbox v-model="item.kesehatan_karyawan" :checked="item.kesehatan_karyawan==1"></a-checkbox>
              </template> -->
              <template slot="jkk_perusahaan" slot-scope="item">
                <div :class="item.jkk_perusahaan!=item.jkk_perusahaan_sebelum ? 'td_not_same':''">
                  <a-icon class="sts-c" theme="filled" type="check-square" v-if="item.jkk_perusahaan==1"/>
                  <a-icon class="sts-c" type="close-square" v-else/>
                </div>
              </template>
              <template slot="jkm_perusahaan" slot-scope="item">
                <div :class="item.jkm_perusahaan!=item.jkm_perusahaan_sebelum ? 'td_not_same':''">
                  <a-icon class="sts-c" theme="filled" type="check-square" v-if="item.jkm_perusahaan==1"/>
                  <a-icon class="sts-c" type="close-square" v-else/>
                </div>
              </template>
              <template slot="jp_perusahaan" slot-scope="item">
                <div :class="item.jp_perusahaan!=item.jp_perusahaan_sebelum ? 'td_not_same':''">
                  <a-icon class="sts-c" theme="filled" type="check-square" v-if="item.jp_perusahaan==1"/>
                  <a-icon class="sts-c" type="close-square" v-else/>
                </div>
              </template>
              <template slot="jht_perusahaan" slot-scope="item">
                <div :class="item.jht_perusahaan!=item.jht_perusahaan_sebelum ? 'td_not_same':''">
                  <a-icon class="sts-c" theme="filled" type="check-square" v-if="item.jht_perusahaan==1"/>
                  <a-icon class="sts-c" type="close-square" v-else/>
                </div>
              </template>
              <template slot="kesehatan_karyawan" slot-scope="item">
                <div :class="item.kesehatan_karyawan!=item.kesehatan_karyawan_sebelum ? 'td_not_same':''">
                  <a-icon class="sts-c" theme="filled" type="check-square" v-if="item.kesehatan_karyawan==1"/>
                  <a-icon class="sts-c" type="close-square" v-else/>
                </div>
              </template>
              <template slot="jp_karyawan" slot-scope="item">
                <div :class="item.jp_karyawan!=item.jp_karyawan_sebelum ? 'td_not_same':''">
                  <a-icon class="sts-c" theme="filled" type="check-square" v-if="item.jp_karyawan==1"/>
                  <a-icon class="sts-c" type="close-square" v-else/>
                </div>
              </template>
              <template slot="jht_karyawan" slot-scope="item">
                <div :class="item.jht_karyawan!=item.jht_karyawan_sebelum ? 'td_not_same':''">
                  <a-icon class="sts-c" theme="filled" type="check-square" v-if="item.jht_karyawan==1"/>
                  <a-icon class="sts-c" type="close-square" v-else/>
                </div>
              </template>

              <template slot="footer">
                <a-row :gutter="16">
                  <a-col xs="{ span: 24 }" :lg="{ span: 12 }">
                    <div><b><small>Color Desc:</small></b></div>
                    <div style="display:flex;vertical-align: middle;margin-top:5px;margin-bottom:25px">
                      <div class="r_not_same" style="width:20px;height: 100%;">&nbsp;</div>
                      <small>&nbsp;has a different value from the previous period</small></div>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                    
                  </a-col>
                </a-row>
              </template>
            </a-table>
        </a-collapse-panel>
      </a-collapse>

      <a-card
        class="margin-top"
        :loading="loading.page"
        v-if="dataSource.jenis !== 'manifest'"
      >
        <div slot="title">Manifest Actions</div>

        <a-form :form="form">
          <a-form-item label="Note">
            <a-textarea
              placeholder="Write the note here ... "
              :rows="4"
              v-decorator="['catatan']"
            />
          </a-form-item>
          <a-form-item label="Action">
            <a-select
              showSearch
              v-decorator="['aksi', { rules: [{ required: true }] }]"
            >
              <a-select-option v-for="item in dataSource.aksi" :key="item.aksi">{{
                item.aksi
              }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 24 }">
            <a-button
              @click="handleAction"
              :loading="loading.save"
              block
              type="primary"
              html-type="submit"
              >Save</a-button
            >
          </a-form-item>
        </a-form>
      </a-card>
    </a-spin>
    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="history" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in dataSource.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod.js";

moment.locale('en')

export default {
  name: "cop-deduction-create",
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  props: ["id"],
  data(){
    return {
      loading: {
        page: false,
        delete: false,
        save: false
      },
      dataSource: {
        header: [],
        data: [],
        dataOriginal: []
      },
      search: "",
      pagination: {
        onChange: (page) => {this.pagination.current = page;},
        pageSize: 50,
        current: 1,
        size: "small",
      },
      visibleHistory: false,
      filterBG:{
        putih: false,
        merah: false,
      }
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    Event.$on("confirmMessageReturn", this.handleActionProcess);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleActionProcess);
  },
  mounted(){
    this.fetchData()
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getDateTimeFormat",
      "getCostCenter",
      "getPeruntukan",
      "getSubPeruntukan",
      "getAnggaran",
    ]),
    columns(){
      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: "60px",
          align: "right",
          fixed:"left",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "TLC",
          dataIndex: "tlc",
          key: "tlc",
          width: "100px",
          fixed:"left",
          align: "center",
        },
        {
          title: "Bank Admin",
          key: "admin_bank",
          width: "100px",
          align: "center",
          scopedSlots: { customRender: "admin_bank" },
        },
        {
          title: "COP Company",
          key: "cop_perusahaan",
          width: "170px",
          scopedSlots: { customRender: "cop_perusahaan" },
        },
        {
          title: "COP Employee",
          key: "cop_karyawan",
          width: "170px",
          scopedSlots: { customRender: "cop_karyawan" },
        },
        {
          title: "Employee Debt",
          key: "hutang_karyawan",
          scopedSlots: { customRender: "hutang_karyawan" },
        },
        {
          title: "Health Additional",
          key: "kesehatan_tambahan",
          scopedSlots: { customRender: "kesehatan_tambahan" },
        },
        {
          title: "Cooperative Deduction",
          key: "potongan_koperasi",
          scopedSlots: { customRender: "potongan_koperasi" },
        },
        {
          title: "Project Leader",
          key: "pimpro",
          scopedSlots: { customRender: "pimpro" },
        },
        {
          title: "Car",
          key: "car",
          align:"center",
          scopedSlots: { customRender: "car" },
        },
        {
          title: "Active Days",
          key: "inactive",
          scopedSlots: { customRender: "inactive" },
        },
        {
          title: "Attendence",
          key: "absensi",
          scopedSlots: { customRender: "absensi" },
        },
        {
          title: "meal allowances",
          key: "makan",
          scopedSlots: { customRender: "makan" },
        },
        // {
        //   title: "health benefits",
        //   key: "kesehatan_karyawan",
        //   align: "center",
        //   scopedSlots: { customRender: "kesehatan_karyawan" },
        // },
        {
          title: "JKK Company",
          key: "jkk_perusahaan",
          align: "center",
          scopedSlots: { customRender: "jkk_perusahaan" },
        },
        {
          title: "JKM Company",
          key: "jkm_perusahaan",
          align: "center",
          scopedSlots: { customRender: "jkm_perusahaan" },
        },
        {
          title: "JP Company",
          key: "jp_perusahaan",
          align: "center",
          scopedSlots: { customRender: "jp_perusahaan" },
        },
        {
          title: "JHT Company",
          key: "jht_perusahaan",
          align: "center",
          scopedSlots: { customRender: "jht_perusahaan" },
        },
        {
          title: "Healt Benefit",
          key: "kesehatan_karyawan",
          align: "center",
          scopedSlots: { customRender: "kesehatan_karyawan" },
        },
        {
          title: "JP Employee",
          key: "jp_karyawan",
          align: "center",
          scopedSlots: { customRender: "jp_karyawan" },
        },
        {
          title: "JHT Employee",
          key: "jht_karyawan",
          align: "center",
          scopedSlots: { customRender: "jht_karyawan" },
        },
      ]
        return kolom
    }
  },
  methods:{
    moment,
    fetchData(){
      this.loading.page = true
      this.asyncAxiosGet("komponen_gaji",
        this.getAuth,
        { id_komponen: this.id}
      )
      .then((response) => {
        this.dataSource = response
        this.dataSource['dtlOri'] = response.dtl
        this.loading.page = false
      })
      .catch((err) => {
        console.log(err);
      });
    },
    downloadFile(){
      window.open(this.$serviceUrl + this.dataSource.header.lampiran_path);
    },
    handleEdit(){
      this.$router.push({
        name: "salary-component-edit-hrd",
        params: { id: this.id },
      });
    },
    handleDelete(){
      const that = this;
      let title = "";
      title = "Are you sure to delete this data?";
      that.$confirm({
        title: title,
        content: "Yes / No?",
        okText: "Yes",
        cancelText: "No",
        onOk() {


          that.loading.delete = true
          that.asyncAxiosDelete(
            "komponen_gaji",
            "application/json",
            that.getAuth,
            {
              id_payment: that.id
            }
          )
          .then(() => {
            that.displayMessage("success-delete")
            that.$router.push({ name: "CopList" });
          })
          .catch(() => {
            that.loading.delete = false
          });
        },
        onCancel() {},
      })
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    handleAction() {
      this.confirmMessage("confirm-save");
    },
    handleActionProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        let data = new FormData();
        data.append("id_komponen", this.id);
        data.append("tlc", this.getAuth.username);
        data.append("status", values.aksi);
        data.append("remark", values.catatan ? values.catatan : "");

        this.loading.save = true
        this.asyncAxiosPost("komponen_gaji/approval","formdata", this.getAuth,data)
          .then(() => {
            this.displayMessage("success");
            this.$router.go();
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    onChangeWhiteCheck(){
      this.filterWarna(this.search)
    },
    filterWarna(val){
      if(val){ 
        this.dataSource.dtl = this.dataSource.dtlOri.filter(item => item.tlc.toLowerCase().indexOf(val.toLowerCase()) >=0 )
      }else{
        this.dataSource.dtl = this.dataSource.dtlOri
      }

      if(this.filterBG.putih){
        this.dataSource.dtl = this.dataSource.dtl.filter(
          item => item.absensi==item.absensi_sebelum &&
                  item.admin_bank==item.admin_bank_sebelum && 
                  item.cop_perusahaan==item.cop_perusahaan_sebelum &&
                  item.cop_karyawan==item.cop_karyawan_sebelum &&
                  item.hutang_karyawan==item.hutang_karyawan_sebelum &&
                  item.inactive==item.inactive_sebelum &&
                  item.jht_karyawan==item.jht_karyawan_sebelum &&
                  item.jht_perusahaan==item.jht_perusahaan_sebelum &&
                  item.jkk_perusahaan==item.jkk_perusahaan_sebelum &&
                  item.jkm_perusahaan==item.jkm_perusahaan_sebelum &&
                  item.jp_karyawan==item.jp_karyawan_sebelum &&
                  item.jp_perusahaan==item.jp_perusahaan_sebelum &&
                  item.kesehatan_karyawan==item.kesehatan_karyawan_sebelum &&
                  item.kesehatan_perusahaan==item.kesehatan_perusahaan_sebelum &&
                  item.kesehatan_tambahan==item.kesehatan_tambahan_sebelum &&
                  item.makan==item.makan_sebelum &&
                  item.mobil==item.mobil_sebelum &&
                  item.pimpro==item.pimpro_sebelum &&
                  item.potongan_koperasi==item.potongan_koperasi_sebelum
        )
      }

      if(this.filterBG.merah){
        this.dataSource.dtl = this.dataSource.dtl.filter(
          item => item.absensi!=item.absensi_sebelum ||
                  item.admin_bank!=item.admin_bank_sebelum || 
                  item.cop_perusahaan!=item.cop_perusahaan_sebelum ||
                  item.cop_karyawan!=item.cop_karyawan_sebelum ||
                  item.hutang_karyawan!=item.hutang_karyawan_sebelum ||
                  item.inactive!=item.inactive_sebelum ||
                  item.jht_karyawan!=item.jht_karyawan_sebelum ||
                  item.jht_perusahaan!=item.jht_perusahaan_sebelum ||
                  item.jkk_perusahaan!=item.jkk_perusahaan_sebelum ||
                  item.jkm_perusahaan!=item.jkm_perusahaan_sebelum ||
                  item.jp_karyawan!=item.jp_karyawan_sebelum ||
                  item.jp_perusahaan!=item.jp_perusahaan_sebelum ||
                  item.kesehatan_karyawan!=item.kesehatan_karyawan_sebelum ||
                  item.kesehatan_perusahaan!=item.kesehatan_perusahaan_sebelum ||
                  item.kesehatan_tambahan!=item.kesehatan_tambahan_sebelum ||
                  item.makan!=item.makan_sebelum ||
                  item.mobil!=item.mobil_sebelum ||
                  item.pimpro!=item.pimpro_sebelum ||
                  item.potongan_koperasi!=item.potongan_koperasi_sebelum
        )
      }
    }
  },
  watch:{
    "search"(val){
      if(val){ 
        this.dataSource.dtl = this.dataSource.dtlOri.filter(item => item.tlc.toLowerCase().indexOf(val.toLowerCase()) >=0 )
      }else{
        this.dataSource.dtl = this.dataSource.dtlOri
      }
    }
  }
}
</script>
<style lang="less" scoped>
.ccd:deep{
  .ant-table-thead {
    th {
      text-transform: uppercase;
      text-align: center;
    }
  }
}
</style>
<style lang="less">
  .mcdm{
    .ant-card-head-title{
      margin-right:0px
    }
  }

  .r_same { 
    background-color: fade(@color-secondary, 35%)!important;
  }

  .r_not_same { 
    background-color: fade(@color-primary, 35%)!important;
  }

  td:has(.td_not_same) {
    background-color: fade(@color-primary, 35%)!important;
  }

  .sts-c{
    font-size: large;
  }
</style>